<template>
    <main-content-wrapper>
        <h1 class="text-md-center">Dostop samo za člane</h1>
        <v-flex xs12 sm12>
            <p class="text-sm-center">
                Dostop do storitve je omogočen samo TUŠ klub članom.
            </p>
            <p>&nbsp;</p>
            <p class="text-sm-center">
                <v-btn depressed @click="joinClub()" color="primary_action_small">Ustvarite račun ali povežite Tuš kartico</v-btn>
            </p>
        </v-flex>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";

    export default {
        name: "NeedToBeMember",
        components: {MainContentWrapper},
        mounted() {
            this.$trackPageVisit('not-tus-club-member');
        },
        methods: {
            joinClub(){
                this.$router.push('/ustvari/izbira');
            }
        }
    }
</script>

<style scoped>

</style>